import { Link } from "react-router-dom";
import { blogs } from "./BlogData";


const BlogPage = () => {
  return (
    <section className="py-12 bg-gray-50">
      <h1 className="md:text-4xl text-2xl font-serif text-[#b76d68] py-6 text-center mb-6">
        Our Blogs
      </h1>
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8">
        {blogs.slice(0, 3).map((blog) => (
          <div
            key={blog.id}
            className="bg-white rounded-xl shadow-md overflow-hidden"
          >
            <img
              src={blog.image}
              alt={blog.title}
              className="h-56 w-full object-cover"
            />

            <div className="p-6">
              <h3 className="text-lg font-semibold mb-3">{blog.title}</h3>

              <Link
                to={`/blog/${blog.id}`}
                className="text-red-500 font-medium hover:underline"
              >
                Read More →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogPage;
